import axios from 'axios';

export const submitContact = async (payload) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/contacts`, payload);
  return response.data;
};
